import BottomNavBarMobile from './BottomNavBarMobile'
import TopNavBarMobile from './TopNavbarMobile'
const MobileNavbar = ()=>{
    return(
        <>
            <TopNavBarMobile></TopNavBarMobile>
            <BottomNavBarMobile></BottomNavBarMobile>
        </>
    )
}
export default MobileNavbar